import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { useAuth } from 'lib/useAuth';
import { CheckCircle } from 'ui/CheckCircle';
import { ReceiptForm } from './ReceiptForm';
import { useResendReceipt } from './hooks/useResendReceipt';

interface SummarySendReceiptSectionProps {
    orderId: number;
    title: string;
    footer: string;
    sentMessage: string;
}

export const SummarySendReceiptSection: React.FC<SummarySendReceiptSectionProps> = ({
    orderId,
    title,
    footer,
    sentMessage
}) => {
    const { user } = useAuth();
    const theme = useTheme();
    const { send, loading, sent } = useResendReceipt(orderId);

    const handleSubmit = React.useCallback(({ email }: { email: string }) => send(email), [send]);

    if (sent) {
        return (
            <Box px={2} py={2} display="flex" justifyContent="center" alignItems="center" gap={1}>
                <CheckCircle color={theme.palette.primary.main} width={20} height={20} />
                <Typography align="center">{sentMessage}</Typography>
            </Box>
        );
    }

    return (
        <Box px={2} py={2}>
            <Typography
                align="center"
                variant="h6"
                sx={{ fontWeight: theme.typography.fontWeightBold, color: 'text.primary', pb: 1 }}
            >
                {title}
            </Typography>
            <ReceiptForm defaultEmail={user?.email ?? ''} onSubmit={handleSubmit} isLoading={loading} />
            <Typography align="center" variant="caption" sx={{ display: 'block', mt: 1 }}>
                {footer}
            </Typography>
        </Box>
    );
};
